<template>
  <div>
    <div class="main-page">
        <!-- Start Header -->
        <header class="header-area formobile-menu header--transparent black-logo-version ">
            <div class="header-wrapper" id="header-wrapper">
                <div class="header-left">
                    <div class="logo">
                        <a href="/">
                            <img src="assets/logo3.png" alt="VietSpeak community" width = "200">
                        </a>
                    </div>
                </div>
                <div class="header-right">
                    <div class="mainmenunav d-lg-block">
                        <!-- Start Mainmanu Nav -->
                        <nav class="main-menu-navbar">
                            <ul class="mainmenu">
                                <li class="has-droupdown">
                                    <a href="#">Trang chủ</a>                                 
                                </li>
                               <!--  <li class="has-droupdown">
                                    <a href="service.html">Service</a>
                                    <ul class="submenu">
                                        <li><a href="service.html">Service</a></li>
                                        <li><a href="service-details.html">Service Details</a></li>
                                    </ul>
                                </li> -->
                                <li>
                                    <a href="about.html">Giới thiệu</a>
                                </li>
                               <!--  <li class="has-droupdown">
                                    <a href="blog.html">Pages</a>
                                    <ul class="submenu">
                                        <li> <a href="blog.html">Blog List</a></li>
                                        <li><a href="blog-details.html">Blog Details</a></li>
                                        <li><a href="service.html">Service</a></li>
                                        <li><a href="service-details.html">Service Details</a></li>
                                        <li><a href="portfolio.html">Portfolio</a></li>
                                        <li><a href="portfolio-details.html">Portfolio Details</a></li>
                                        <li><a href="404.html">404 Page</a></li>
                                    </ul>
                                </li>
                                <li class="has-droupdown">
                                    <a href="#">Blocks</a>
                                    <ul class="submenu">
                                        <li><a href="portfolio.html">Portfolio</a></li>
                                        <li><a href="team.html">Team</a></li>
                                        <li><a href="service.html">Service</a></li>
                                        <li><a href="video-popup.html">Video Popup</a></li>
                                        <li><a href="progressbar.html">Progress Bar</a></li>
                                        <li><a href="gallery.html">Gallery</a></li>
                                        <li><a href="counterup.html">Counters</a></li>
                                        <li><a href="blog.html">Blog List</a></li>
                                        <li><a href="brand.html">Client Logo</a></li>
                                        <li><a href="contact-form.html">Contact Form</a></li>
                                        <li><a href="columns.html">Columns</a></li>
                                        <li><a href="button.html">Button</a></li>
                                        <li><a href="liststyle.html">List Style</a></li>
                                        <li><a href="testimonial.html">Testimonial</a></li>
                                        <li><a href="accordion.html">Accordion</a></li>
                                    </ul>
                                </li>
                                <li>
                                    <a href="contact.html">Contact</a>
                                </li> -->
                            </ul>
                        </nav>
                        <!-- End Mainmanu Nav -->

                    </div>
                    <div class="header-btn">
                        <a class="rn-btn" href="https://airtable.com/shr9lanI3t9jJ3STm">
                            <span>Tham gia với chúng tớ!</span>
                        </a>
                    </div>
                    <!-- Start Humberger Menu  -->
                    <div class="humberger-menu d-block d-lg-none pl--20">
                        <span class="menutrigger text-white">
                    <i data-feather="menu"></i>
                </span>
                    </div>
                    <!-- End Humberger Menu  -->
                    <!-- Start Close Menu  -->
                    <div class="close-menu d-block d-lg-none">
                        <span class="closeTrigger">
                    <i data-feather="x"></i>
                </span>
                    </div>
                    <!-- End Close Menu  -->
                </div>
            </div>
        </header>
        <!-- Start Page Wrapper  -->
        <main class="page-wrapper">
            <!-- Start Slider Area  -->
            <div class="rn-slider-area">
                <!-- Start Single Slide  -->
                <div class="slide slide-style-1 slider-fixed--height d-flex align-items-center bg_image bg_image--1" data-black-overlay="6">
                    <div class="container position-relative">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="inner">
                                    <h1 class="title theme-gradient">VietSpeak </h1> <br><h2 class="title theme-gradient"> town</h2>
                                </div>
                            </div>
                        </div>
                        <div class="service-wrapper service-white">
                            <div class="row">

                                <!-- Start Single Service  -->
                                <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                                    <div class="single-service service__style--3 text-white">
                                        <div class="icon">
                                            <img src="assets/images/icons/icon-01.png" alt="Creative Agency" />
                                        </div>
                                        <div class="content">
                                            <h3 class="title">Mục tiêu</h3>
                                            <p class = "font-jost">VietSpeak giúp bạn nói tiếng anh thành thạo, thuần thục thông qua luyện đọc.</p>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Single Service  -->

                                <!-- Start Single Service  -->
                                <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                                    <div class="single-service service__style--3 text-white">
                                        <div class="icon">
                                            <img src="assets/images/icons/icon-02.png" alt="Creative Agency" />
                                        </div>
                                        <div class="content">
                                            <h3 class="title">Chủ trương</h3>
                                            <p class = "font-jost">Cộng đồng VietSpeak non-profit,thân thiện, kỉ luật, đề cao tự giác và tự nguyện.</p>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Single Service  -->

                                <!-- Start Single Service  -->
                                <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                                    <div class="single-service service__style--3 text-white">
                                        <div class="icon">
                                            <img src="assets/images/icons/icon-03.png" alt="Creative Agency" />
                                        </div>
                                        <div class="content">
                                            <h3 class="title">Sự khác biệt ?</h3>
                                            <p class = "font-jost">Cộng đồng luyện nói trên VietSpeak kết nối người Việt học và sử dụng tiếng Anh khắp năm châu. Join us, free, bạn sẽ tiến bộ bằng cách luyện cơ miệng hàng tuần, áp lực ghê gớm đấy!</p>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Single Service  -->

                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Single Slide  -->
            </div>
            <!-- End Slider Area  -->

            <!-- Start About Area  -->
            <div class="about-area about-position-top pb--120">
                <div class="about-wrapper">
                    <div class="container">
                        <div class="row row--35 align-items-center">
                            <div class="col-lg-5 col-md-12">
                                <div class="thumbnail">
                                    <img class="w-100" src="assets/images/about/about-1.jpg" alt="About Images" />
                                </div>
                            </div>
                            <div class="col-lg-7 col-md-12">
                                <div class="about-inner inner">
                                    <div class="section-title">
                                        <h2 class="title">About</h2>
                                        <p class="description font-jost">There are many variations of passages of Lorem Ipsum
                                            available, but the majority have suffered alteration in some form, by
                                            injected humour, or randomised words which dont look even slightly
                                            believable. If you are going to use a passage of Lorem Ipsum,</p>
                                    </div>
                                    <div class="row mt--30 mt_sm--10">
                                        <div class="col-lg-6 col-md-12 col-sm-12 col-12">
                                            <div class="about-us-list">
                                                <h3 class="title">Who we are</h3>
                                                <p class = "font-jost">There are many vtions of passages of Lorem Ipsum available, but the
                                                    majority have suffered.</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-12 col-sm-12 col-12">
                                            <div class="about-us-list">
                                                <h3 class="title">Who we are</h3>
                                                <p class = "font-jost">There are many vtions of passages of Lorem Ipsum available, but the
                                                    majority have suffered.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Start About Area  -->

            <!-- Start Service Area  -->
            <div class="rn-service-area ptb--80 bg_image bg_image--3">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-4 col-12">
                            <div class="section-title text-left mt--30 mt_md--5 mt_mobile--5 mb_mobile--10">
                                <h2 class="title">Services</h2>
                                <p class = "font-jost">There are many variations of passages of Lorem Ipsum available, but the majority have
                                    suffered alteration.</p>
                                <div class="service-btn"><a class="btn-transparent rn-btn-dark" href="/service"><span
                                            class="text">Request Custom Service</span></a></div>
                            </div>
                        </div>
                        <div class="col-lg-8 col-12 mt_md--50">
                            <div class="row service-one-wrapper">

                                <!-- Start Single Service  -->
                                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                    <div class="single-service service__style--4">
                                        <a href="service-details.html">
                                            <div class="service">
                                                <div class="icon">
                                                    <i data-feather="cast"></i>
                                                </div>
                                                <div class="content">
                                                    <h3 class="title">Business Stratagy</h3>
                                                    <p class = "font-jost">I throw myself down among the tall grass by the stream as I lie
                                                        close to
                                                        the earth.</p>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <!-- End Single Service  -->

                                <!-- Start Single Service  -->
                                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                    <div class="single-service service__style--4">
                                        <a href="service-details.html">
                                            <div class="service">
                                                <div class="icon">
                                                    <i data-feather="layers"></i>
                                                </div>
                                                <div class="content">
                                                    <h3 class="title">Website Development</h3>
                                                    <p class = "font-jost">I throw myself down among the tall grass by the stream as I lie
                                                        close to
                                                        the earth.</p>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <!-- End Single Service  -->

                                <!-- Start Single Service  -->
                                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                    <div class="single-service service__style--4">
                                        <a href="service-details.html">
                                            <div class="service">
                                                <div class="icon">
                                                    <i data-feather="users"></i>
                                                </div>
                                                <div class="content">
                                                    <h3 class="title">Marketing & Reporting</h3>
                                                    <p class = "font-jost">I throw myself down among the tall grass by the stream as I lie
                                                        close to
                                                        the earth.</p>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <!-- End Single Service  -->

                                <!-- Start Single Service  -->
                                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                    <div class="single-service service__style--4">
                                        <a href="service-details.html">
                                            <div class="service">
                                                <div class="icon">
                                                    <i data-feather="monitor"></i>
                                                </div>
                                                <div class="content">
                                                    <h3 class="title">Mobile Development</h3>
                                                    <p class = "font-jost">I throw myself down among the tall grass by the stream as I lie
                                                        close to
                                                        the earth.</p>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <!-- End Single Service  -->

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Start Service Area  -->

           
            <!-- Start Counterup Area  -->
            <div class="rn-counterup-area pt--25 pb--110 bg_color--1">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="section-title text-center">
                                <h3 class="fontWeight500 m-y-2 font-jost">Một số thống kê:</h3>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <!-- Start Single Counterup  -->
                        <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                            <div class="rn-counterup counterup_style--1">
                                <h5 class="counter count">22</h5>
                                <p class="description">Tổng số task đã thực hiện...</p>
                            </div>
                        </div>
                        <!-- Start Single Counterup  -->

                        <!-- Start Single Counterup  -->
                        <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                            <div class="rn-counterup counterup_style--1">
                                <h5 class="counter count">1500</h5>
                                <p class="description">Tổng số thành viên đã tham gia từ trước đến nay.</p>
                            </div>
                        </div>
                        <!-- Start Single Counterup  -->

                        <!-- Start Single Counterup  -->
                        <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                            <div class="rn-counterup counterup_style--1">
                                <h5 class="counter count">0</h5>
                                <p class="description">Hãy nói về học phí học đồ một tí đi?</p>
                            </div>
                        </div>
                        <!-- Start Single Counterup  -->
                    </div>
                </div>
            </div>
            <!-- End Counterup Area  -->

            <!-- Start Testimonial Area  -->
            <div class="rn-testimonial-area rn-section-gap bg_color--5">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <!-- Start Tab Content  -->
                            <div class="rn-testimonial-content tab-content" id="myTabContent">
                                <div class="tab-pane fade show active" id="tab1" role="tabpanel" aria-labelledby="tab1-tab">
                                    <div class="inner">
                                        <p class = "font-jost">"Học chết bỏ, tưởng dễ thở, ai ngờ các bố Việt Speak kỉ luật phát ớn. Mà free nghen".</p>
                                    </div>
                                    <div class="author-info">
                                        <h6 class = "font-jost"><span class = "font-jost">Hiếu Nguyễn </span> Kế toán đẹp trai, hát hay, Hà Nội.</h6>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="tab2" role="tabpanel" aria-labelledby="tab2-tab">
                                    <div class="inner">
                                        <p>Việt Speak giúp mình phát hiện và chữa lỗi hay dã man.</p>
                                    </div>
                                    <div class="author-info">
                                        <h6><span>Fatima Asrafy </span> - COO, AMERIMAR ENTERPRISES, INC.</h6>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="tab3" role="tabpanel" aria-labelledby="tab3-tab">
                                    <div class="inner">
                                        <p>Aklima The standard chunk of Lorem Ipsum used since the 1500s is reproduced
                                            below for those interested. Sections Bonorum et Malorum original.</p>
                                    </div>
                                    <div class="author-info">
                                        <h6><span>Fatima Asrafy </span> - COO, AMERIMAR ENTERPRISES, INC.</h6>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="tab4" role="tabpanel" aria-labelledby="tab4-tab">
                                    <div class="inner">
                                        <p>Aklima The standard chunk of Lorem Ipsum used since the 1500s is reproduced
                                            below for those interested. Sections Bonorum et Malorum original.</p>
                                    </div>
                                    <div class="author-info">
                                        <h6><span>Fatima Asrafy </span> - COO, AMERIMAR ENTERPRISES, INC.</h6>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="tab5" role="tabpanel" aria-labelledby="tab5-tab">
                                    <div class="inner">
                                        <p>Aklima The standard chunk of Lorem Ipsum used since the 1500s is reproduced
                                            below for those interested. Sections Bonorum et Malorum original.</p>
                                    </div>
                                    <div class="author-info">
                                        <h6><span>Fatima Asrafy </span> - COO, AMERIMAR ENTERPRISES, INC.</h6>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="tab6" role="tabpanel" aria-labelledby="tab6-tab">
                                    <div class="inner">
                                        <p>Aklima The standard chunk of Lorem Ipsum used since the 1500s is reproduced
                                            below for those interested. Sections Bonorum et Malorum original.</p>
                                    </div>
                                    <div class="author-info">
                                        <h6><span>Fatima Asrafy </span> - COO, AMERIMAR ENTERPRISES, INC.</h6>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="tab7" role="tabpanel" aria-labelledby="tab7-tab">
                                    <div class="inner">
                                        <p>Aklima The standard chunk of Lorem Ipsum used since the 1500s is reproduced
                                            below for those interested. Sections Bonorum et Malorum original.</p>
                                    </div>
                                    <div class="author-info">
                                        <h6><span>Fatima Asrafy </span> - COO, AMERIMAR ENTERPRISES, INC.</h6>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="tab8" role="tabpanel" aria-labelledby="tab8-tab">
                                    <div class="inner">
                                        <p>Aklima The standard chunk of Lorem Ipsum used since the 1500s is reproduced
                                            below for those interested. Sections Bonorum et Malorum original.</p>
                                    </div>
                                    <div class="author-info">
                                        <h6><span>Fatima Asrafy </span> - COO, AMERIMAR ENTERPRISES, INC.</h6>
                                    </div>
                                </div>
                            </div>
                            <!-- End Tab Content  -->

                            <!-- Start Tab Nav  -->
                            <ul class="testimonial-thumb-wrapper nav nav-tabs" id="myTab" role="tablist">
                                <li>
                                    <a class="active" id="tab1-tab" data-toggle="tab" href="#tab1" role="tab" aria-controls="tab1" aria-selected="true">
                                        <div class="testimonial-thumbnai">
                                            <div class="thumb">
                                                <img src="assets/images/client/testimonial-1.jpg" alt="Testimonial Images">
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a id="tab2-tab" data-toggle="tab" href="#tab2" role="tab" aria-controls="tab2" aria-selected="false">
                                        <div class="testimonial-thumbnai">
                                            <div class="thumb">
                                                <img src="assets/images/client/testimonial-2.jpg" alt="Testimonial Images">
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a id="tab3-tab" data-toggle="tab" href="#tab3" role="tab" aria-controls="tab3" aria-selected="false">
                                        <div class="testimonial-thumbnai">
                                            <div class="thumb">
                                                <img src="assets/images/client/testimonial-3.jpg" alt="Testimonial Images">
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a id="tab4-tab" data-toggle="tab" href="#tab4" role="tab" aria-controls="tab4" aria-selected="false">
                                        <div class="testimonial-thumbnai">
                                            <div class="thumb">
                                                <img src="assets/images/client/testimonial-4.jpg" alt="Testimonial Images">
                                            </div>
                                        </div>
                                    </a>
                                </li>

                                <li>
                                    <a id="tab5-tab" data-toggle="tab" href="#tab5" role="tab" aria-controls="tab5" aria-selected="false">
                                        <div class="testimonial-thumbnai">
                                            <div class="thumb">
                                                <img src="assets/images/client/testimonial-5.jpg" alt="Testimonial Images">
                                            </div>
                                        </div>
                                    </a>
                                </li>

                                <li>
                                    <a id="tab6-tab" data-toggle="tab" href="#tab6" role="tab" aria-controls="tab6" aria-selected="false">
                                        <div class="testimonial-thumbnai">
                                            <div class="thumb">
                                                <img src="assets/images/client/testimonial-6.jpg" alt="Testimonial Images">
                                            </div>
                                        </div>
                                    </a>
                                </li>

                                <li>
                                    <a id="tab7-tab" data-toggle="tab" href="#tab7" role="tab" aria-controls="tab7" aria-selected="false">
                                        <div class="testimonial-thumbnai">
                                            <div class="thumb">
                                                <img src="assets/images/client/testimonial-7.jpg" alt="Testimonial Images">
                                            </div>
                                        </div>
                                    </a>
                                </li>

                                <li>
                                    <a id="tab8-tab" data-toggle="tab" href="#tab8" role="tab" aria-controls="tab8" aria-selected="false">
                                        <div class="testimonial-thumbnai">
                                            <div class="thumb">
                                                <img src="assets/images/client/testimonial-8.jpg" alt="Testimonial Images">
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                            <!-- End Tab Content  -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- Start Testimonial Area  -->

            <!-- Start Blog Area  -->
            <div class="rn-blog-area rn-section-gapTop bg_color--1">
                <div class="container">
                    <div class="row align-items-end mb--20">
                        <div class="col-lg-6 col-md-12 col-sm-12 col-12">
                            <div class="section-title text-left">
                                <h2>Latest News</h2>
                                <p>There are many variations of passages of Lorem Ipsum available, but the majority have
                                    suffered alteration.</p>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12 col-sm-12 col-12">
                            <div class="blog-btn text-left text-lg-right mt_sm--10 mt_md--10">
                                <a class="btn-transparent rn-btn-dark" href="blog.html"><span class="text">View All
                                        News</span></a>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <!-- Start Blog Area  -->
                        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="blog blog-style--1">
                                <div class="thumbnail">
                                    <a href="blog-details.html">
                                        <img class="w-100" src="assets/images/blog/blog-01.jpg" alt="Blog Images" />
                                    </a>
                                </div>
                                <div class="content">
                                    <p class="blogtype">Development</p>
                                    <h4 class="title"><a href="blog-details.html">Getting tickets to the big show</a>
                                    </h4>
                                    <div class="blog-btn">
                                        <a class="rn-btn text-white" href="blog-details.html">Read More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Blog Area  -->

                        <!-- Start Blog Area  -->
                        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="blog blog-style--1">
                                <div class="thumbnail">
                                    <a href="blog-details.html">
                                        <img class="w-100" src="assets/images/blog/blog-02.jpg" alt="Blog Images" />
                                    </a>
                                </div>
                                <div class="content">
                                    <p class="blogtype">Development</p>
                                    <h4 class="title"><a href="blog-details.html">Getting tickets to the big show</a>
                                    </h4>
                                    <div class="blog-btn">
                                        <a class="rn-btn text-white" href="blog-details.html">Read More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Blog Area  -->

                        <!-- Start Blog Area  -->
                        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="blog blog-style--1">
                                <div class="thumbnail">
                                    <a href="blog-details.html">
                                        <img class="w-100" src="assets/images/blog/blog-03.jpg" alt="Blog Images" />
                                    </a>
                                </div>
                                <div class="content">
                                    <p class="blogtype">Development</p>
                                    <h4 class="title"><a href="blog-details.html">Getting tickets to the big show</a>
                                    </h4>
                                    <div class="blog-btn">
                                        <a class="rn-btn text-white" href="blog-details.html">Read More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Blog Area  -->

                    </div>
                </div>
            </div>
            <!-- End Blog Area  -->

            <!-- Start Brand Area -->
            <div class="rn-brand-area brand-separation">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <ul class="brand-style-2">
                                <li>
                                    <img src="assets/images/brand/brand-01.png" alt="Logo Images" />
                                </li>
                                <li>
                                    <img src="assets/images/brand/brand-02.png" alt="Logo Images" />
                                </li>
                                <li>
                                    <img src="assets/images/brand/brand-03.png" alt="Logo Images" />
                                </li>
                                <li>
                                    <img src="assets/images/brand/brand-04.png" alt="Logo Images" />
                                </li>
                                <li>
                                    <img src="assets/images/brand/brand-05.png" alt="Logo Images" />
                                </li>
                                <li>
                                    <img src="assets/images/brand/brand-06.png" alt="Logo Images" />
                                </li>
                                <li>
                                    <img src="assets/images/brand/brand-02.png" alt="Logo Images" />
                                </li>
                                <li>
                                    <img src="assets/images/brand/brand-03.png" alt="Logo Images" />
                                </li>
                                <li>
                                    <img src="assets/images/brand/brand-04.png" alt="Logo Images" />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <!-- End Brand Area -->

        </main>
        <!-- End Page Wrapper  -->
        <footer class="footer-area footer-default">
            <div class="footer-wrapper">
                <div class="row align-items-end row--0">
                    <div class="col-lg-6">
                        <div class="footer-left">
                            <div class="inner">
                                <span>Sẵn sàng tham gia rồi chứ? 
                                </span>
                                <h2 class = "font-jost">Nói tiếng Anh <br /> bằng cách đọc to thôi bồ tèo!</h2>
                                    <a class="rn-button-style--2" href="https://airtable.com/shr9lanI3t9jJ3STm">
                                        <span>Join us</span>
                                    </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="footer-right" data-black-overlay="6">
                            <div class="row">
                                <!-- Start Single Widget -->
                                <div class="col-lg-6 col-sm-6 col-12">
                                    <div class="footer-widget">
                                        <h4>Quick Link</h4>
                                        <ul class="ft-link">
                                            <li><a href="portfolio.html">Work</a></li>
                                            <li><a href="about.html">About</a></li>
                                            <li><a href="contact.html">Let's Talk</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <!-- End Single Widget  -->
                                <!-- Start Single Widget -->
                                <div class="col-lg-6 col-sm-6 col-12 mt_mobile--30">
                                    <div class="footer-widget">
                                        <h4>Say Hello</h4>
                                        <ul class="ft-link">
                                            <li><a href="mailto:admin@example.com">contact@vietspeak.org</a></li>                                           
                                        </ul>

                                        <div class="social-share-inner">
                                            <ul class="social-share social-style--2 d-flex justify-content-start liststyle mt--15">
                                                <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                                <li><a href="#"><i class="fab fa-linkedin-in"></i></a></li>
                                                <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                                <li><a href="#"><i class="fab fa-instagram-square"></i></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Single Widget  -->

                                <div class="col-lg-12">
                                    <div class="copyright-text">
                                        <p>Copyright © 2020 Việt Speak. Bảo lưu mọi bản quyền.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>


<style scoped>

</style>
